import { Component, OnInit, ChangeDetectorRef, AfterViewInit, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { RequestService } from 'src/app/services/request.service';
import { AlertsService } from 'src/app/services/alerts.service';

@Component({
  selector: 'app-add-carbon',
  templateUrl: './add-carbon.component.html',
  styleUrls: ['./add-carbon.component.scss']
})
export class AddCarbonComponent implements OnInit, AfterViewInit {
  carbonForm!: FormGroup;
  carbonFields: string[] = [
    'crop_type',
    'size (ha)',
    'energy_consumption (kWh/ha)',
    'total_nitrogen (Kg)',
    'fuel_consumption (kgCO₂ /l)',
    'ef_fuel (kgCO₂ /l)',
    'residues_amount (KG/ha)',
    'efresidue (kg CO₂/kg)',
    'spraying_fuel_consumption (L)',
    'spraying_ef_fuel (kg CO₂/l)',
    'total_spraying (Kg)',
    'factor_spraying_emissions (kg CO₂/kg)',
    'rsequestration (kg CO₂/ha/year)'
  ];
  dropdownFields: string[] = [
    'ef_fuel',
    'efresidue',
    'spraying_ef_fuel',
    'factor_spraying_emissions',
    'rsequestration'
  ];
  dropdownOptions: { [key: string]: { label: string; value: number }[] } = {
    ef_fuel: [
      { label: 'Πετρέλαιο: ~2,67 kg CO₂/l', value: 2.6 },
      { label: 'Βενζίνης: ~2,31 kg CO₂/l', value: 2.31 }
    ],
    efresidue: [
      { label: 'Καύση Υπολειμμάτων ~ 0.8 kg CO₂/kg', value: 0.8 },
      { label: 'Καύση Υπολειμμάτων ~ 0.9 kg CO₂/kg', value: 0.9 },
      { label: 'Καύση Υπολειμμάτων ~ 1.0 kg CO₂/kg', value: 1.0 },
      { label: 'Αποσύνθεση Υπολειμμάτων (Αερόβια) ~ 0.5 kg CO₂/kg', value: 0.5 },
      { label: 'Αποσύνθεση Υπολειμμάτων (Αερόβια) ~ 0.6 kg CO₂/kg', value: 0.6 },
      { label: 'Αποσύνθεση Υπολειμμάτων (Αερόβια) ~ 0.7 kg CO₂/kg', value: 0.7 },
      { label: 'Αποσύνθεση Υπολειμμάτων (Αερόβια) ~ 0.8 kg CO₂/kg', value: 0.8 },
      { label: 'Αποσύνθεση Υπολειμμάτων (Αναερόβια) ~ 0.2 kg CO₂/kg', value: 0.2 },
      { label: 'Αποσύνθεση Υπολειμμάτων (Αναερόβια) ~ 0.3 kg CO₂/kg', value: 0.3 },
      { label: 'Αποσύνθεση Υπολειμμάτων (Αναερόβια) ~ 0.4 kg CO₂/kg', value: 0.4 },
      { label: 'Αποσύνθεση Υπολειμμάτων (Αναερόβια) ~ 0.5 kg CO₂/kg', value: 0.5 },
      { label: 'Υπολειμμάτων με Οργανική ~ 0.4 kg CO₂/kg', value: 0.4 },
      { label: 'Υπολειμμάτων με Οργανική ~ 0.5 kg CO₂/kg', value: 0.5 },
      { label: 'Υπολειμμάτων με Οργανική ~ 0.6 kg CO₂/kg', value: 0.6 },
      { label: 'Υπολειμμάτων με Οργανική ~ 0.7 kg CO₂/kg', value: 0.7 }
    ],
    factor_spraying_emissions: [
      { label: 'Εντομοκτόνα ~ 5 kg CO₂/kg', value: 5 },
      { label: 'Εντομοκτόνα ~ 6 kg CO₂/kg', value: 6 },
      { label: 'Εντομοκτόνα ~ 7 kg CO₂/kg', value: 7 },
      { label: 'Εντομοκτόνα ~ 8 kg CO₂/kg', value: 8 },
      { label: 'Ζιζανιοκτόνα ~ 4 kg CO₂/kg', value: 4 },
      { label: 'Ζιζανιοκτόνα ~ 5 kg CO₂/kg', value: 5 },
      { label: 'Ζιζανιοκτόνα ~ 6 kg CO₂/kg', value: 6 },
      { label: 'Μυκητοκτόνα ~ 3 kg CO₂/kg', value: 3 },
      { label: 'Μυκητοκτόνα ~ 4 kg CO₂/kg', value: 4 },
      { label: 'Μυκητοκτόνα ~ 5 kg CO₂/kg', value: 5 }
    ],
    spraying_ef_fuel: [
      { label: 'Πετρέλαιο: ~2,67 kg CO₂/l', value: 2.6 },
      { label: 'Βενζίνης: ~2,31 kg CO₂/l', value: 2.31 }
    ],
    rsequestration: [
      { label: 'Ελαιώνες ~ 850', value: 850 },
      { label: 'Βαμβάκι ~ 200', value: 200 },
      { label: 'Πορτοκάλια ~ 500', value: 500 },
      { label: 'Σιτάρι ~ 300', value: 300 },
      { label: 'Καλαμπόκι ~ 400', value: 400 },
      { label: 'Αμύγδαλα ~ 600', value: 600 },
      { label: 'Κτηνοτροφικά Βοσκοτόπια ~ 300', value: 300 },
      { label: 'Αμπέλια ~ 750', value: 750 }
    ]
  };
  @Output() carbonSaved = new EventEmitter<any>();

  constructor(
    private dialogRef: MatDialogRef<AddCarbonComponent>,
    private fb: FormBuilder,
    private req: RequestService<any>,
    private alert: AlertsService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.initForm();
  }

  ngAfterViewInit(): void {
    this.cdr.detectChanges();
  }

  initForm() {
    this.carbonForm = this.fb.group({});
    this.carbonFields.forEach(field => {
      const key = field.split(' ')[0];
      this.carbonForm.addControl(key, this.fb.control(null));
    });
  }

  formatLabel(field: string): string {
    const match = field.match(/^([^\(]+)(\((.*?)\))?$/);
    const main = match?.[1].replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase()) ?? field;
    const unit = match?.[2] ? `<span class="text-xs text-gray-500">${match[2]}</span>` : '';
    return `${main.trim()} ${unit}`;
  }


  fillSoilDataForm(data: any): void {
    this.carbonFields.forEach(field => {
      const key = field.split(' ')[0];
      this.carbonForm.get(key)?.setValue(data[key]);
    });
  }

  saveCurrentAsLocation(): void {
    let obj = {
      crop_type: this.carbonForm.controls['crop_type'].value,
      ef_fuel: this.carbonForm.controls['ef_fuel'].value,
      efresidue: this.carbonForm.controls['efresidue'].value,
      energy_consumption: this.carbonForm.controls['energy_consumption'].value,
      factor_spraying_emissions: this.carbonForm.controls['factor_spraying_emissions'].value,
      fuel_consumption: this.carbonForm.controls['fuel_consumption'].value,
      residues_amount: this.carbonForm.controls['residues_amount'].value,
      rsequestration: this.carbonForm.controls['rsequestration'].value,
      size: this.carbonForm.controls['size'].value,
      spraying_ef_fuel: this.carbonForm.controls['spraying_ef_fuel'].value,
      spraying_fuel_consumption: this.carbonForm.controls['spraying_fuel_consumption'].value,
      total_nitrogen: this.carbonForm.controls['total_nitrogen'].value,
      total_spraying: this.carbonForm.controls['total_spraying'].value,
    }
    this.req.postCarbonFootprint(obj).subscribe({
      next: (res) => {
        this.alert.success('Η καταχώρηση αποθηκεύτηκε επιτυχώς!', 'Success');
        this.carbonSaved.emit(obj)
        this.dialogRef.close();
      },
      error: (err) => {
        console.log(err)
        this.alert.error('Κάτι πήγε στραβά κατά την αποθήκευση.', 'Σφάλμα');
      }
    });
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
